import { LocaleClub } from '../en/club'

const club: LocaleClub = {
  clubs: 'Kelab',
  myClubs: 'Kelab Saya',
  exploreClubs: 'Teroka Kelab',
  requested: 'Permintaan:',
  invited: 'Jemputan:',
  joinClub: 'Sertai Kelab',
  leaveClub: 'Keluar dari Kelab',
  requestPending: 'Permintaan Sedang Diproses',
  invitation: 'Jemputan',
  invitationDesc: 'Anda sedang dijemput oleh pengarah kelab, adakah anda ingin menjadi sebahagian daripada kelab ini?',
  acceptInvitation: 'Anda kini adalah ahli kelab yang dijemput.',
  declineInvitation: 'Anda telah menolak untuk menjadi ahli kelab yang dijemput.',
  editClub: 'Sunting Kelab',
  fixClubPayments: 'Perbaiki isu akaun bayaran kelab.',
  setUpYourClubPayments: 'Tentukan bayaran kelab anda untuk mencipta acara.',
  about: 'Tentang',
  clubDetails: 'Butiran Kelab',
  clubContact: 'Hubungi Kelab',
  clubAbout: 'Tentang Kelab',
  directors: 'Pengarah',
  organizers: 'Penganjur',
  invitePlayers: 'Tambah Ahli',
  importPlayersCSV: 'Import Pemain melalui CSV',
  removeMember: 'Buang ahli',
  removeMemberDesc: 'Ahli ini akan dibuang dari kelab',
  playerAddedSuccess: 'Pemain Ditambah Dengan Jayanya',
  importPlayers: 'Import Pemain',
  importMatchesCSV: 'Import Perlawanan melalui CSV',
  importMatches: 'Import Perlawanan',
  createNewEvent: 'Cipta Acara Baru',
  eventDetails: 'Butiran Acara',
  addOrganizers: 'Tambah Penganjur',
  clubOrganizers: 'Penganjur Kelab mesti mempunyai akaun DUPR untuk ditambah ke kelab anda.',
  clubPlayers: 'Pemain Kelab mesti mempunyai akaun DUPR untuk ditambah ke kelab anda.',
  addOrganizer: 'Tambah Penganjur',
  addMember: 'Tambah Ahli',
  inviteAPLayer: 'Jemput Pemain',
  inviteAPLayerDesc:
    'Selepas anda menjemput mereka, pemain yang dijemput mesti mendaftar (mewujudkan akaun) dengan email yang dimasukkan di bawah untuk melihat keputusan mereka.',
  clubName: 'Nama Kelab',
  removeOrganizerTitle: 'Buang Penganjur Kelab',
  removeOrganizerText: 'Adakah anda pasti ingin mengeluarkan akaun ini sebagai penganjur?',
  removeOrganizer: 'Sahkan',
  createEventDesc:
    'Penanaman dan Pendaftaran tidak tersedia kerana kami sedang menghubungkan anda dengan rakan API kami.',
  seedMatchesDesc:
    'Penanaman tidak lagi tersedia. Kami ingin mempromosikan rakan API Pengurusan Acara kami, pada butang [Daftar] anda kini boleh menampal URL acara anda dari perisian lain',
  leaveDUPRWarning:
    'Anda akan diarahkan ke halaman pendaftaran dan meninggalkan halaman DUPR ini apabila mengklik butang ini.',
  clubsNearMe: 'Kelab Berdekatan',
  clubPosts: 'Pos',
}

export default club
